import React, { PropTypes } from 'react';
import 'styles/core.scss';
import {connect} from 'react-redux';
import Header from 'components/header/header';
import Footer from 'components/footer/footer';
import MainMenu from 'components/header/main-menu/main-menu';
import authenticationService from '../../interactive-solutions/authentication/service/authentication';
import SpinnerPage from '../../views/general/spinner-page';
import TaxkeyService from 'frilans-finans/taxkeys/taxkey-service';
import { UserService } from 'frilans-finans';

export class CoreLayout extends React.Component {

  static propTypes = {
    children: PropTypes.element,
    auth: PropTypes.object,
    menuState: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    taxkeys: PropTypes.array.isRequired,
    topBottomSectionState: PropTypes.object.isRequired
  };

  static childContextTypes = {
    user: React.PropTypes.object,
    taxkeys: React.PropTypes.array
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      user: props.user,
      taxkeys: props.taxkeys,
      loading: true,
      showFooter: true,
      showHeader: true
    };
  }

  componentWillMount = () => {
    // Prevent main menu transition to run on page load
    setTimeout(function () {
      document.querySelector('body').classList.remove('preload');
    }, 1);

    UserService.get().promise.then(function (user) {
      TaxkeyService.get(user.id).done(this.loadingDone);
    }).catch(this.loadingDone);
  }

  loadingDone = () => {
    this.setState({
      loading: false
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      user: nextProps.user,
      taxkeys: nextProps.taxkeys
    });
  }

  getChildContext = () => {
    return {
      user: this.state.user,
      taxkeys: this.state.taxkeys
    };
  }

  renderReady = () => {
    var classes = 'page-wrapper';
    var showFooter = true;
    var showHeader = true;

    if (authenticationService.isAuthenticated) {
      classes += ' logged-in';
    }

    if (this.props.menuState === 'open') {
      classes += ' menu-open';
    }

    if (!this.props.topBottomSectionState.showFooter) {
      showFooter = false;
    }

    if (!this.props.topBottomSectionState.showHeader) {
      showHeader = false;
      classes = 'page-wrapper no-padding';
    }

    return (
      <div className={classes}>
        {showHeader ? <Header /> : ''}
        <MainMenu />
        <div className='view-container'>
          {this.props.children}
        </div>
        {showFooter ? <Footer /> : ''}
      </div>
    );
  }

  render = () => {
    if (!this.state.loading || this.props.auth.reauthenticationStatus === 'fail') {
      return this.renderReady();
    }

    return (<SpinnerPage/>);
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    menuState: state.menuState,
    topBottomSectionState: state.topBottomSectionState,
    user: state.user,
    taxkeys: state.taxkeys
  };
}

export default connect(mapStateToProps)(CoreLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/CoreLayout/CoreLayout.js
 **/